"use client"

import { CharityData } from "@/api/Charities"
import { Carousel, CarouselItem } from "@/components/carousel/Carousel"
import CharityBundleCard from "./CharityBundleCard"

type BundlesCarouselProps = {
  bundles: CharityData[]
}

const buttonStyles =
  "absolute top-[122px] size-[56px] bg-white rounded-full disabled:opacity-0 transition-all duration-800 ease-out flex items-center justify-center shadow-[8.4px_12px_32.76px_0px_rgba(0,0,0,0.25)]"

const BundlesCarousel: React.FC<BundlesCarouselProps> = ({ bundles }) => {
  return (
    <Carousel
      items={bundles}
      innerScrollProps={{ className: "gap-x-0 md:gap-x-[1%] lg:gap-x-[2%] rounded-xl pb-20" }}
      prevButtonProps={{ className: `${buttonStyles}  left-[10px] md:left-[-10px] xl:left-[-28px]` }}
      nextButtonProps={{ className: `${buttonStyles}  right-[10px] md:right-[-10px] xl:right-[-28px]` }}
      paginationButtonProps={{
        className:
          "h-[5px] overflow-hidden bg-gray-40 w-[80px] block-inline rounded-sm [&#active]:bg-red [&#active]:opacity-100 border-y-[20px] border-white box-content",
      }}
      renderItem={({ item, isSnapPoint }) => (
        <CarouselItem key={item.id} isSnapPoint={isSnapPoint} className="w-[100%] md:w-[49.5%] lg:w-[32%]">
          <CharityBundleCard post={item} key={item.id} />
        </CarouselItem>
      )}
    />
  )
}

export default BundlesCarousel
